/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfAppDto } from '../../models/platform-api-result-of-app-dto';

export interface DeleteAppsId$Params {
  id: string;
}

export function deleteAppsId(http: HttpClient, rootUrl: string, params: DeleteAppsId$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfAppDto>> {
  const rb = new RequestBuilder(rootUrl, deleteAppsId.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfAppDto>;
    })
  );
}

deleteAppsId.PATH = '/api/apps/{id}';
